import React, { FC } from 'react';
import { User, Team } from 'api/models';
import { Avatar, AvatarGroup } from 'components/atoms/avatar';
import { fullName } from 'utils/full-name';

type Squad = {
  users: User[];
  teams: Team[];
};

export const SquadAvatarList: FC<{
  squad: Squad;
  size?: 'small' | 'large' | 'default';
  className?: string;
  maxCount?: number;
}> = ({ squad, className, size, maxCount = 2 }) => {
  const users = squad?.users?.map((user) => ({
    key: `u-${user?.userId}`,
    name: fullName(user),
    image: user?.photoUrl,
  }));
  const teams = squad.teams.map((team) => ({
    key: `t-${team?.teamId}`,
    name: team?.teamName,
    image: undefined,
  }));

  const items = [...users, ...teams];

  return (
    <div className={className}>
      <AvatarGroup maxCount={maxCount}>
        {items.map(({ key, name, image }) => (
          <Avatar size={size} key={key} name={name} src={image} />
        ))}
      </AvatarGroup>
    </div>
  );
};
